module.exports = __webpack_public_path__ + "static/media/lamar.ff7ee8ef.mp3";